import getUserGradeNumber from '../grade-number'

const getUserFullName = (
    user = {},
    {
        grade,
        familyFirst
    } = {}
) => {
    if (!user) {
        return 'UNKNOWN'
    }

    let result = ''

    if (user.lastName || user.firstName) {
        if (user.lastName && user.firstName) {
            if (familyFirst) {
                result = `${user.lastName}, ${user.firstName}`
            } else {
                result = `${user.firstName} ${user.lastName}`
            }
            
        } else {
            result = user.lastName || user.firstName
        }
    }

    if (!result && user.email) {
        result = user.email
    }

    if (!result) {
        result = 'UNKNOWN'
    }

    if (grade && user.gradYear) {
        const gradeNumber = getUserGradeNumber(user.gradYear)
        if (gradeNumber) {
            result = `${result} (${gradeNumber})`
        }
        
    }

    return result
}

export default getUserFullName